import { render, staticRenderFns } from "./NewArea.vue?vue&type=template&id=d35d0a2c"
import script from "./NewArea.vue?vue&type=script&lang=js"
export * from "./NewArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports